module.exports = __webpack_public_path__ + "static/media/nowe_logo_firmy_emitel.87f49596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nowe_logo_firmy_emitel.png
// module id = 371
// module chunks = 0